// 维修列表
import request from "@/utils/request";

// 作品编辑
export function workEdit(data) {
  return request({
    url: "/work/edit",
    method: "post",
    data,
  });
}

// 升班
export function clazzUpgrade(data) {
  return request({
    url: "/clazz/upgrade",
    method: "post",
    data,
  });
}

// 班级导入 /clazz/import
// 在API文件中
export function clazzImport(clazzId, data) {
  return request({
    url: "/clazz/import",
    method: "post",
    params: { clazzId }, // clazzId 作为查询参数
    data, // 文件数据
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

//删除班级
export function clazzDelete(data) {
  return request({
    url: "/clazz/delete",
    method: "post",
    params: { ...data },
  });
}

// 查询班级的详情信息
export function clazzDetail(data) {
  return request({
    url: "/clazz/detail",
    method: "post",
    params: { ...data },
  });
}

// 新增/编辑班级
export function clazzAddOrEdit(data) {
  return request({
    url: "/clazz/addOrEdit",
    method: "post",
    data,
  });
}

// 班级分页查询
export function clazzPage(data) {
  return request({
    url: "/clazz/page",
    method: "post",
    data,
  });
}

// 查询所有的班级信息
export function getAllClazzList(data) {
  return request({
    url: "/clazz/all",
    method: "post",
    params: { ...data },
  });
}

// 查看所有的年级的信息
export function gradeAll(data) {
  return request({
    url: "/grade/all",
    method: "post",
    data,
  });
}

// /clazz/downloadTemplate
export function clazzDownloadTemplate() {
  return request({
    url: "/clazz/downloadTemplate",
    method: "post",
    responseType: "blob",
  });
}

// 作品档案
export function workArchive(ids) {
  const params = new URLSearchParams();
  ids.forEach((id) => {
    params.append("ids", id);
  });
  return request({
    url: "/work/generateDoc",
    method: "post",
    data: params, // 注意：是 data，不是 params
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    responseType: "blob",
    timeout: 1000000, 
  });
}
